import api from "@/api/api-v2-config";

export async function getPurchaseOrderListAxios() {    
    return await api.get("purchaseorders?pageNumber=1&pageSize=10000");
}

export async function deletePurchaseOrdersAxios(id) {    
    return await api.delete("purchaseorders?Id=" + id);
}

export async function postPurchaseOrdersAxios(purchaseorders) {    
    return await api.post("purchaseorders", purchaseorders);
}

export async function putPurchaseOrdersAxios(purchaseorders) {    
    return await api.put("purchaseorders", purchaseorders);
}

export async function getPurchaseOrdersByIDAxios(id) {    
    return await api.get("purchaseorders/" + id);
}

// export async function getProductOrderAxios(productorder) {    
//     return await api.get("purchaseorders/getproductorder", productorder);
// }

export async function getPurchaseOrderDocumentList(ReferenceID) {
    return await api.get(`purchaseorders/files?ReferenceID=${ReferenceID}&PageNumber=1&PageSize=10000`);
}

export async function deletePurchaseOrderDocument(id) {
    return await api.delete("purchaseorders/files/" + id);
}

export async function uploadPurchaseOrderDocument(file, referenceId, type, typeId) {
    console.log(file, referenceId);
    const formData = new FormData();
    formData.append('File', file[0]);
    formData.append('ReferenceId', referenceId);
    formData.append('type', type);
    formData.append('typeId', typeId);
    api.defaults.headers["Content-Type"] = "multipart/form-data";
    return await api.post('purchaseorders/files/upload', formData);
}

export async function uploadPurchaseOrderMultipleDocuments(files, referenceId, type, typeId) {
    console.log(files, referenceId);
    const formData = new FormData();
    files.forEach(file => {
        formData.append('Files', file);
    });
    formData.append('ReferenceId', referenceId);
    formData.append('type', type);
    formData.append('typeId', typeId);
    api.defaults.headers["Content-Type"] = "multipart/form-data";
    return await api.post('purchaseorders/files/uploads', formData);
}

export async function downloadPurchaseOrderDocument(id) {
    api.defaults.headers["responseType"] = "blob";
    return await api.get("purchaseorders/files/download/" + id);
}